/* eslint-disable */

export default {
  init() {
    $(".accordion-title").on("click", function () {
      $(this).toggleClass("open");
      $(this).next().slideToggle();
      $(this).children(".closed").toggleClass("hide");
      $(this).children(".open").toggleClass("show");
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js